import React, { Component } from 'react';
import { Button, Form } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import { TextField } from "../common/FormComponents";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { toArray } from "../common/util";
import { Row, Alert } from 'react-bootstrap';
import { connect } from 'react-redux';
import { entitySelector } from "../redux/selectors";
import { fetchEntities } from "../redux/actions";
import { onlyDecimal } from "./EventsForm";
import { MenuItem } from '@material-ui/core';

const validate = values => {
    const errors = {};

    if (!values.eventEntity) {
        errors.eventEntity = '* Required'
    }
    if (!values.dkp) {
        errors.dkp = '* Required'
    }
    return errors;
};


class EventsEntityForm extends Component {

    componentDidMount() {
        for (var loc of this.props.event.location) {
            this.props.getEntities(this.props.event.chapterId, this.props.locations.data[loc].slug)
        }
    }

    render() {
        const { handleSubmit } = this.props;
        const onKeyPress = (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
            }
        };
        return (
            <Form onSubmit={handleSubmit}>
                <Row>
                    <Field component={TextField}
                        name="eventEntity"
                        select
                        type="text"
                        label="Boss"
                        helperText={<span></span>}
                        style={{ "width": "142px" }}
                        onChange={event => {
                            if (event.type === "click") {
                                console.log(event.target.value)
                                this.props.change('dkp', toArray(this.props.entities.data).filter((entity) => entity.title === event.target.value)[0].dkp);
                            }
                            // else if (event.type === "change") {
                            //     if (toArray(this.props.entities.data).filter((entity) => entity.title.toLowerCase() === event.target.value.toLowerCase()).length)
                            //         this.props.change('dkp', toArray(this.props.entities.data).filter((entity) => entity.title.toLowerCase() === event.target.value.toLowerCase())[0].dkp);
                            // }
                        }}
                    >
                        {toArray(this.props.entities.data)
                            .sort((a, b) => (b.id - a.id)).map((entity) => (
                                <MenuItem key={entity.id} value={entity.title}>{entity.title}</MenuItem>
                            ))}
                    </Field>

                    <Field component={TextField}
                        name="dkp"
                        type="text"
                        label="DKP Value"
                        onChange={this.handleChange}
                        normalize={onlyDecimal}
                        onKeyPress={onKeyPress}
                    />
                    <Button type="submit" disabled={this.props.pristine || this.props.pending}>
                        {(this.props.pending) ? (
                            <FontAwesomeIcon className="text-primary" icon={faSpinner} spin fixedWidth />
                        ) : (null)}
                        Add Kill
                    </Button>
                    {this.props.errors ? (
                        <Alert bsStyle="danger">{this.props.errors}</Alert>
                    ) : (null)
                    }
                </Row>
            </Form>
        )
    }
}

const mapStateToProps = (state) => ({
    entities: entitySelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getEntities: (chapter, location) => dispatch(fetchEntities(chapter, location)),
});

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({ form: 'eventsEntityForm', validate, })(EventsEntityForm))


// WEBPACK FOOTER //
// ./src/Officer/EventsEntityForm.js